import { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { useTitle } from 'react-use';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { captchaSetIsActive } from 'CorePackage/CaptchaModule/actions/captchaActions';
import { getCaptchaToken } from 'CorePackage/CaptchaModule/selectors/captchaSelectors';
import { Layout } from 'CorePackage/MainModule/components/Layout';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ROUTE_PORTAL } from 'CorePackage/MainModule/constants/routes';

import { KnmHeader } from './KnmHeader';
import { KnmCommon } from './KnmCommon';
import { ErknmCommon } from './ErknmCommon';
import { PmCommon } from './PmCommon';
import { KnmControl } from './KnmControl';
import { ErknmControl } from './ErknmControl';
import { PmControl } from './PmControl';
import { KnmProsecutor } from './KnmProsecutor';
import { KnmFace } from './KnmFace';
import { ErknmFace } from './ErknmFace';
import { PmFace } from './PmFace';
import { ErknmAct } from './ErknmAct';
import { ErknmResult } from './ErknmResult';
import { KnmErpObject } from './KnmErpObject';
import { PmResult } from './PmResult';
import { KnmViolation } from './KnmViolation';
import styles from './styles.module.scss';
import { passportKnmGetDataByQr, passportKnmGetData } from '../actions/passportKnmActions';
import { getPassportKnmData, getPassportKnmErrorStatus } from '../reducers/passportKnmReducer';
import { KnmErpObjectErvk } from './KnmErpObjectErvk';

interface IPassportKnmStoreProps {
  captchaToken: string | null;
  passportData?: IKnmPreview;
  errorStatus?: number;
}

const PassportKnmWithoutStore = ({ passportData, errorStatus, captchaToken }: IPassportKnmStoreProps) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useTitle('Публичный паспорт проверки');
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const [activeTab, setActiveTab] = useState('common');
  const { id, token } = useParams<{ id: string; token: string }>();

  const isErknm = passportData?.version === 'ERKNM';
  const isErpPm = passportData?.version === 'ERP' && passportData?.pmErknm;
  const isPm = (isErknm && passportData?.pmErknm) || isErpPm;

  useEffect(() => {
    if (
      token &&
      passportData &&
      (passportData.status === 'Не может быть проведено' || passportData.status === 'Не согласована')
    ) {
      history.push(`${ROUTE_PORTAL}?mt=${isPm ? 'pm' : 'knm'}`);
    }
  }, [passportData, token, history, isPm]);

  useEffect(() => {
    if (token) {
      dispatch(passportKnmGetDataByQr(token));
    } else if (typeof captchaToken !== 'undefined') {
      if (!captchaToken) {
        dispatch(captchaSetIsActive(true));
      } else {
        dispatch(passportKnmGetData(id));
      }
    }
  }, [id, token, captchaToken, dispatch]);

  if (errorStatus === 504) {
    return <div>Удаленный сервер не отвечает</div>;
  }
  if (errorStatus && errorStatus >= 500 && errorStatus <= 599) {
    return <div>Ошибка на сервере</div>;
  }

  const hasViolation = () => {
    const objects = passportData?.objects?.length;
    const violations = passportData?.objects?.some(obj => !!obj?.result?.violations?.length);
    return !!objects && !!violations;
  };

  return (
    <Layout>
      <div className={styles.Container}>
        {passportData && (
          <>
            <KnmHeader activeTab={activeTab} setActiveTab={setActiveTab} hasViolation={hasViolation()} />
            <div className={styles.KnnWrapperContent}>
              {activeTab === 'common' &&
                (isErknm || isErpPm ? (
                  (isPm && <PmCommon passportData={passportData} />) || <ErknmCommon passportData={passportData} />
                ) : (
                  <KnmCommon passportData={passportData} />
                ))}
              {activeTab === 'act' && <ErknmAct passportData={passportData} />}
              {activeTab === 'resultDecisions' && <ErknmResult passportData={passportData} />}
              {activeTab === 'control' &&
                (isErknm || isErpPm ? (
                  (isPm && <PmControl passportData={passportData} />) || <ErknmControl passportData={passportData} />
                ) : (
                  <KnmControl passportData={passportData} />
                ))}
              {activeTab === 'prosecutor' && <KnmProsecutor passportData={passportData} />}
              {activeTab === 'face' &&
                (isErknm || isErpPm ? (
                  (isPm && <PmFace passportData={passportData} />) || <ErknmFace passportData={passportData} />
                ) : (
                  <KnmFace passportData={passportData} />
                ))}
              {activeTab === 'result' && isPm && <PmResult passportData={passportData} />}
              {activeTab === 'result' && !isPm && passportData.objectsErvk && (
                <KnmErpObjectErvk passportData={passportData} />
              )}
              {activeTab === 'result' && !isPm && !passportData.objectsErvk && (
                <KnmErpObject passportData={passportData} />
              )}
              {activeTab === 'violation' && <KnmViolation passportData={passportData} />}
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};

const mapStateToProps = (state: IRootState) => ({
  captchaToken: getCaptchaToken(state),
  passportData: getPassportKnmData(state),
  errorStatus: getPassportKnmErrorStatus(state),
});

export const PassportKnm = connect(mapStateToProps)(PassportKnmWithoutStore);
